export enum ImageExtension {
  JPG = 'jpg',
  PNG = 'png',
  WEBP = 'webp',
}

export enum ImageSize {
  VERTICAL_CARD = 'ar_2:3,w_320',
  HORIZONTAL_CARD = 'ar_16:9,w_320,c_fill',
  CAROUSEL = 'ar_3:1,w_1684,c_fill,g_auto',
  HERO = 'ar_16:9,w_1344,c_fill',
  TITLE = 'ar_16:9,w_420',
  SOUNDTRACK = 'ar_1:1,w_240,c_fill',
  ACTOR_SQUARED = 'ar_1:1,w_230,c_fill',
  ACTOR_ROUNDED = 'ar_1:1,w_240,c_fill',
  ACTOR_RECTANGULAR = 'ar_1:1,w_240,c_fill',
  VIDEO_THUMBNAIL = 'ar_16:9,w_1920,c_fill',
}
